module.exports = __webpack_public_path__ + "static/media/tastingnotes_grapes.a836bf09.png";